module.exports = new __parcel__URL__("Sales Portal.53643a97.svg").toString();